<script setup>
import {ref, onMounted, computed} from 'vue';
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { supabase } from '@/supabase'
import Button from 'primevue/button'
import ProgressBar from 'primevue/progressbar'
import Card from 'primevue/card'
import Tag from 'primevue/tag'
import Dialog from 'primevue/dialog'

import store from '@/store'

const router = useRouter()
const route = useRoute()

const parecer = ref('');
const loading = computed(() => store.state.loading);

function goBack() {
    router.push({ path: '/estudante/' })
}


const userSession = store.state.userSession.user.idU;
onMounted(async () => {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('pareceres')
        .select('parecer')
        .eq('estudante', userSession)

    parecer.value = formatTextWithLineBreaks(data[0].parecer);

    store.dispatch('updateLoading', false)
    console.log(data)
})

function formatTextWithLineBreaks(text) {
    return text.replace(/\n\n/g, '<br><br>');
}
</script>

<template>
    <div>
        <ProgressBar v-if="loading" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
        <div class="header border-bottom-1 border-200 z-3">
            <div class="text-color text-xl flex align-items-center">
                <Button @click="goBack" icon="pi pi-arrow-left" text rounded aria-label="Filter" severity="secondary" />
                <span class="ml-2">Parecer humanas 1° tri</span>
            </div>
        </div>
        <div class="p-3 pt-8">
            <div v-if="parecer !== ''" class="container flex gap-3 flex-column" v-html="parecer"></div>
            <div v-if="parecer === '' && loading === false">Seu parecer ainda não está disponível.</div>
        </div>
    </div>


</template>

<style>
span.p-tag.p-component.p-tag-rounded.tag-aulas {
    min-width: 55px;
}
</style>